export const sortMediaOptions = (params = {}) => {
  const { bySize, byName, byType } = params;
  const options = [];

  options.push({
    orderBy: 'date',
    orderAsc: false,
    label: __('Newest'),
    icon: 'arrow-up-3',
    action: 'orderMedia',
    selected: true,
    default: true,
    order: 0, // used for sorting photos/albums/tags
  });

  options.push({
    orderBy: 'date',
    orderAsc: true,
    label: __('Oldest'),
    icon: 'arrow-down-3',
    action: 'orderMedia',
      selected: false,
      order: 1, // used for sorting photos/albums/tags
    },
  );

  if (bySize) {
    options.push({
      orderBy: 'size',
      orderAsc: false,
      label: __('Largest size'),
      icon: 'document-upload',
      action: 'orderMedia',
      selected: false,
    });
    options.push({
      orderBy: 'size',
      orderAsc: true,
      label: __('Smallest size'),
      icon: 'document-download',
      action: 'orderMedia',
      selected: false,
    });
  }

  if (byName) {
    options.push({
      orderBy: 'name',
      orderAsc: true,
      label: __('Alphabetical ascending'),
      icon: 'quote-up',
      action: 'orderMedia',
      selected: false,
    });
    options.push({
      orderBy: 'name',
      orderAsc: false,
      label: __('Alphabetical descending'),
      icon: 'quote-down',
      action: 'orderMedia',
      selected: false,
    });
  }

  if (byType) {
    options.push({
      orderBy: 'type',
      orderAsc: true,
      label: __('Kind'),
      icon: 'category-2',
      action: 'orderMedia',
      selected: false,
    });
  }

  return {
    subOptions: options,
  };
};

export const sortMembersOptions = () => {
  return {
    subOptions: [
      {
        label: __('Recently Added'),
        action: 'sortMembers',
        selected: true,
        default: true,
        order: 'recency',
      },
      {
        label: __('First Name'),
        action: 'sortMembers',
        selected: false,
        order: 'firstname',
      },
      {
        label: __('Last Name'),
        action: 'sortMembers',
        selected: false,
        order: 'lastname',
      },
    ],
  }
};
